import { EventEmitter, Injectable, Output } from '@angular/core';
import { QuoteSettings } from '../models/quote';
import { OfferFilters } from '../models/offer-filters';

@Injectable({
  providedIn: 'root',
})
export class QuoteSettingsService {
  @Output() quoteSettingsUpdated = new EventEmitter<QuoteSettings>();
  @Output() offerFiltersUpdated = new EventEmitter<OfferFilters>();

  public quoteSettings: QuoteSettings;
  public quoteSettingsQuoteRequestId: number;
  public pendingRestore = false;
  public offerFilters: OfferFilters;

  constructor() {}

  public updateQuoteSettings(quoteRequestId: number, quoteSettings: QuoteSettings) {
    this.quoteSettingsQuoteRequestId = quoteRequestId;
    this.quoteSettings = quoteSettings;
    this.pendingRestore = true;
    this.quoteSettingsUpdated.emit(quoteSettings);
  }

  public updateOfferFilters(offerFilters: OfferFilters) {
    this.offerFilters = offerFilters;
    this.offerFiltersUpdated.emit(offerFilters);
  }
}
